import { Modal, Table } from "antd";
import dayjs from "dayjs";

const ShowDuplicateQueryDetailsModal = ({
  isModalOpen = false,
  duplicateQueriesList = [],
  setIsModalOpen = () => {}
}) => {
  const handleOk = () => {
    setIsModalOpen(false);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const columns = [
    {
      title: "S No.",
      dataIndex: "index",
      key: "index"
    },
    {
      title: "Title",
      key: "title",
      render: (row) => (
        <u>
          <a href={row.threadLink} target="_blank" rel="noreferrer">
            {row.title}
          </a>
        </u>
      )
    },
    {
      title: "Created At",
      dataIndex: "createdAt",
      key: "createdAt",
      render: (createdAt) => dayjs(createdAt).format("DD MMM YYYY | HH:mm")
    },
    {
      title: "Mentor",
      dataIndex: "mentor",
      key: "mentor"
    },
    {
      title: "Student Email",
      dataIndex: "studentEmail",
      key: "studentEmail"
    }
  ];

  return (
    <Modal
      title="Duplicate Query Details"
      open={isModalOpen}
      footer={null}
      onOk={handleOk}
      onCancel={handleCancel}
      width="90vw"
      bodyStyle={{
        overflowX: "auto",
        padding: 16
      }}
    >
      <Table
        columns={columns}
        dataSource={duplicateQueriesList}
        bordered
        scroll={{ x: "max-content" }}
      />
    </Modal>
  );
};
export default ShowDuplicateQueryDetailsModal;
